import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useSearchParams } from 'next/navigation';
import { useTranslations } from 'next-intl';
import { useMessageContext } from '@/components/Messages';
function useShowPaymentError() {
  const $ = _c(7);
  const {
    addMessage
  } = useMessageContext();
  const t0 = useSearchParams();
  let t1;
  if ($[0] !== t0) {
    t1 = t0.get("payment_failed");
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const redirectStatus = t1;
  const t = useTranslations("nextjs.donate.errors");
  let t2;
  let t3;
  if ($[2] !== addMessage || $[3] !== redirectStatus || $[4] !== t) {
    t2 = () => {
      if (redirectStatus !== "true") {
        return;
      }
      addMessage({
        type: "error",
        message: t("stripe_wero_payment_failed")
      });
    };
    t3 = [addMessage, redirectStatus, t];
    $[2] = addMessage;
    $[3] = redirectStatus;
    $[4] = t;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
}
export default useShowPaymentError;